import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import Popper from '@di-shared/features/common/Popper';

function MileageBalanceTooltip() {
  const {t} = useInferableTranslation();

  return (
    <Popper
      placement="bottom"
      className="tooltip"
      marginLeft={3}
      tooltip={
        <>
          <strong className="tooltip_title">{t('T30267')}</strong>
          <ul className="tooltip_list">
            <li className="tooltip_item">{t('T30268')}</li>
            <li className="tooltip_item">{t('T30269')}</li>
          </ul>
        </>
      }
    >
      <div className="tooltip_area tooltip_area_single">
        <button
          type="button"
          className="btn_tooltip"
          aria-describedby="tooltipBox03"
          aria-controls="tooltipStatement01"
          aria-expanded="false"
        >
          <span
            className="ic ic_information_16px"
            aria-hidden="true"
          ></span>
          <span className="blind">{t('T10044')}</span>
        </button>
      </div>
    </Popper>
  );
}

export default MileageBalanceTooltip;
